import { supabase } from './client';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = supabase as any;

export type AdPlacement = 'forum-sidebar' | 'blog-sidebar';

export type AdCampaign = {
  id: string;
  name: string;
  image_url: string;
  click_url: string;
  placement: AdPlacement;
  weight: number;
  active: boolean;
  active_from: string | null;
  active_to: string | null;
  created_at: string;
  updated_at: string;
};

export type PickedAd = {
  id: string;
  name: string;
  image_url: string;
  click_url: string;
};

export async function pickAdForPlacement(placement: AdPlacement): Promise<PickedAd | null> {
  const { data, error } = await db.rpc('pick_ad_for_placement', {
    p_placement: placement,
  });
  if (error) {
    // Migration 0015 not run yet, or RPC signature changed — fail open
    // so ad slots just render nothing rather than breaking the page.
    return null;
  }
  const rows = (data ?? []) as PickedAd[];
  return rows[0] ?? null;
}

export async function fetchAllCampaigns(): Promise<AdCampaign[]> {
  const { data, error } = await db
    .from('ad_campaigns')
    .select(
      'id, name, image_url, click_url, placement, weight, active, active_from, active_to, created_at, updated_at',
    )
    .order('placement')
    .order('created_at', { ascending: false });
  if (error) {
    if (error.code === '42P01') return [];
    throw error;
  }
  return (data ?? []) as AdCampaign[];
}

export type AdCampaignInput = {
  name: string;
  image_url: string;
  click_url: string;
  placement: AdPlacement;
  weight?: number;
  active?: boolean;
  active_from?: string | null;
  active_to?: string | null;
};

export async function createCampaign(input: AdCampaignInput): Promise<void> {
  const { error } = await db.from('ad_campaigns').insert(input);
  if (error) throw error;
}

export async function updateCampaign(id: string, patch: Partial<AdCampaignInput>): Promise<void> {
  const { error } = await db.from('ad_campaigns').update(patch).eq('id', id);
  if (error) throw error;
}

export async function deleteCampaign(id: string): Promise<void> {
  const { error } = await db.from('ad_campaigns').delete().eq('id', id);
  if (error) throw error;
}
